<script setup>
import { computed, ref } from 'vue'

const props = defineProps({
  submitting: { type: Boolean, default: false },
  // 后端返回的字段级错误，形如 [{ field: 'title', message: '...' }]
  fieldErrors: { type: Array, default: () => [] }
})

const emit = defineEmits(['create'])

const title = ref('')
const options = ref(['', ''])

const filledOptions = computed(() => options.value.map((o) => o.trim()).filter(Boolean))
const canSubmit = computed(
  () => !props.submitting && title.value.trim().length > 0 && filledOptions.value.length >= 2
)

function errorFor(field) {
  return props.fieldErrors.find((item) => item.field === field)?.message
}

function addOption() {
  if (options.value.length < 8) options.value.push('')
}

function removeOption(index) {
  if (options.value.length > 2) options.value.splice(index, 1)
}

function submit() {
  if (!canSubmit.value) return
  emit('create', {
    title: title.value,
    options: filledOptions.value,
    // 由父组件在成功后调用，表单不关心请求是否成功。
    reset: () => {
      title.value = ''
      options.value = ['', '']
    }
  })
}
</script>

<template>
  <form class="card" @submit.prevent="submit">
    <h3>新建投票</h3>

    <label>
      <span>问题</span>
      <input v-model="title" placeholder="例如：周末去哪儿玩？" maxlength="120" />
      <small v-if="errorFor('title')" class="err">{{ errorFor('title') }}</small>
    </label>

    <div class="options">
      <span class="legend">选项（2–8 个，不可重复）</span>
      <div v-for="(option, index) in options" :key="index" class="row">
        <input v-model="options[index]" :placeholder="'选项 ' + (index + 1)" maxlength="80" />
        <button
          type="button"
          class="ghost"
          :disabled="options.length <= 2"
          :aria-label="'删除选项 ' + (index + 1)"
          @click="removeOption(index)"
        >✕</button>
      </div>
      <small v-if="errorFor('options')" class="err">{{ errorFor('options') }}</small>
      <button type="button" :disabled="options.length >= 8" @click="addOption">+ 添加选项</button>
    </div>

    <button class="primary" type="submit" :disabled="!canSubmit">
      {{ submitting ? '提交中…' : '创建投票' }}
    </button>
  </form>
</template>

<style scoped>
.card {
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 14px;
  padding: 18px;
  display: grid;
  gap: 14px;
  position: sticky;
  top: 24px;
}

h3 { margin: 0; font-size: 17px; }

label { display: grid; gap: 6px; font-size: 14px; }
label span { color: var(--muted); }

.options { display: grid; gap: 8px; }
.legend { font-size: 14px; color: var(--muted); }
.row { display: flex; gap: 8px; }
.ghost { color: var(--muted); background: transparent; border-color: transparent; padding: 2px 8px; }
.ghost:hover:not(:disabled) { color: #ff7b72; }
.err { color: #ff7b72; font-size: 13px; }
</style>
